export default {
    h1: 'Instant Online 1-ON-1 Tutoring',
    desc: 'For Whenever Your Child Needs Help',
    button: 'Arrange A Trial Lesson',
    title1: 'Commitment To Safety',
    title2: 'As seen in',
    name: 'Screen Tutors',
    list: [
        [
            {
                name: 'Screen Tutors',
                desc: `Every tutor applicant is reviewed by the AirClass team. Our network of tutors includes certified teachers, professionals and
        upperclass college students that are individually screened and trained.`
            },
            {
                name: 'Secure Communication',
                desc: `All communication takes place within AirClass’ secure platform.Our system is set to inhibit any inappropriate communication or
            exchange of personal information`
            },
            {
                name: '24/7 Support',
                desc: `The AirClass team is always available to respond to any questions, concerns or ideas. We aren’t just here for problems, but
            also help guide you down the right academic track`
            },
        ],
        [
            {
                title: 'Advanced lesson space',
                desc: 'Our innovative online classroom provides the closest experience there is to an in-person tutoring lesson'
            },
            {
                title: 'Academic Advisors',
                desc: `AirClass can help students outside the classroom as well. Our in-house academic advisors work with students on
            time-management, study skills and career paths.`
            },
            {
                title: 'Tutors From Top Universities',
                desc: `Highly qualified tutors from the best universities across the globe ready to help. An acceptance rate of 7.8% means all our
            tutors are thoroughly screened`
            }
        ]
    ]
}